export default "__VITE_ASSET__kI4XDUas__"